import { ProductDTO } from '../domain/models';

const STORAGE_KEY = 'products';

export class ProductService {
  load(): ProductDTO[] {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const arr = raw ? (JSON.parse(raw) as ProductDTO[]) : [];
      // ensure numeric unitPrice
      return arr.map(p => ({ ...p, unitPrice: Number(p.unitPrice ?? 0) }));
    } catch {
      return [];
    }
  }

  saveAll(products: ProductDTO[]) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
    } catch {
      // ignore
    }
  }

  upsert(products: ProductDTO[], product: ProductDTO): ProductDTO[] {
    const id = product.id ?? Date.now();
    const next = { ...product, id } as ProductDTO;
    const idx = products.findIndex(p => (p.id ?? '') === id);
    if (idx >= 0) {
      const copy = products.slice();
      copy[idx] = next;
      return copy;
    }
    return [...products, next];
  }

  remove(products: ProductDTO[], id?: number): ProductDTO[] {
    if (id == null) return products;
    return products.filter(p => p.id !== id);
  }

  findByKey(products: ProductDTO[], key?: string): ProductDTO | undefined {
    if (!key) return undefined;
    const q = key.trim().toLowerCase();
    return products.find(p => (p.productKey || '').toLowerCase() === q);
  }
}
